import _ from "lodash"

export const func = {
  domPurify: html => {
    return html.replace(/</g, "&lt;").replace(/>/g, "&gt;")
  },
  htmlBr: html => {
    if (!html) return ""
    return html.replace(/\n/g, "<br />")
  },
}
